import React, { useEffect, useState } from "react";
import { DKLabel, DKButton, DKSpinner, DKInput, INPUT_VIEW_DIRECTION, DKRadioButton, showLoader, showToast, TOAST_TYPE, removeLoader, DKTooltipWrapper, DKIcon } from "deskera-ui-library";
import { MANAGE_COMP_OFF_FIELDS, LOCATION_COLUMN_CONFIG } from "./CompOffConstants";
import { CONSTANTS, INPUT_TYPE } from "../../constants/Constant";
import Utility, { deepClone } from "../../utility/Utility";
import { useSelector } from "react-redux";
import { selectUsers } from "../../Redux/Slices/PayrollSlice";
import EmployeeListService from "../../services/EmployeeListService";
import { useTranslation } from "react-i18next";
import { CompoffService } from "../../services/CompOffService";
import moment, { duration } from "moment";
import { getLocationValueAndLabel } from "../configs/config";
import TenantManager from "../../managers/TenantManager";
import { selectLocationDimentionList } from "../../Redux/Slices/LocationListSlice";
import { selectCustomField } from "../../Redux/Slices/CustomFieldsSlice";
import ic_erro_info from "../../assets/icons/ic_info_error.svg";
import {convertDateToJson, reverseTimezoneOffset} from "../../managers/common/CommonUtil";


const InitialiseCompOff = (props) => {

    const { t } = useTranslation();

    /**Hooks */

    const [formFieldConfig, setFormFieldConfig] = useState(MANAGE_COMP_OFF_FIELDS);
    const [formValues, setFormValues] = useState({
        duration: "fullDay",
        expiryMode: "noOfDays",
        isForAllUsers: { id: "N", name: "No" },
        isAttachmentMandatory: { id: false, name: "No" }
    });
    const [isEdit, setEditFlag] = useState(props.isEdit);
    const [dataToUpdate, setDataToUpdate] = useState(props.data);
    const [isProcessing, setProcessing] = useState(false);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [existingCompOffData, setExistingCompOffData] = useState([]);

    /**Selectors */
    const userList = useSelector(selectUsers);
    const locationData = useSelector(selectLocationDimentionList);
    const customFieldsData = useSelector(selectCustomField);
    /**Dispatch */

    // useEffect(() => {
    //     updateFormConfigWithLocationAndCustomFields();
    // }, []);

    useEffect(() => {
        setProcessing(true);
        let config = updateFormFieldConfigOptions();
        updateFormConfigWithLocationAndCustomFields(config);
        if (isEdit) {
            updateFormConfigForEdit(config);
            updateFormValues(config);
        }
        setFormFieldConfig(config);
        setProcessing(false);
    }, [userList]);

    useEffect(() => {
        // if (isEdit) {
        //     updateFormConfigForEdit();
        //     updateFormValues();
        // }
    }, [props.isEdit])

    const updateFormConfigWithLocationAndCustomFields = (columnConfig) => {
        let config = columnConfig;
        config = updateLocationColumnConfig(config);
        config = updateCustomFieldsColumnConfig(config);

        // setFormFieldConfig(config);
    }

    const updateCustomFieldsColumnConfig = (columnConfig) => {
        let { customFields } = customFieldsData;
        customFields = customFields?.filter(field=>field.isActive) || [];
        customFields?.forEach((c) => {
            let group = {};
            group['id'] = c.id;
            group['name'] = c.name;
            group['columnCode'] = c.id;
            group['key'] = c.id;
            group['uiVisible'] = true;
            group['required'] = c.isMandatory;
            group = getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldValidationList = (c) => {
        const validation = [];
    }

    const getFieldConfigOnType = (group, c) => {
        switch (c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                group['maxLength'] = c.maxLength;
                group['validation'] = ['maxLength'];
                if(c.isMandatory) {
                    group['validation'] = [...group['validation'], 'required']
                }
                formValues[c.id] = !Utility.isEmpty(c?.defaultValue) ? c.defaultValue[0] : "";
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                group['decimalPrecision'] = c.decimalPrecision;
                group['validation'] = ['decimalPrecision'];
                if(c.isMandatory) {
                    group['validation'] = [...group['validation'], 'required']
                }
                formValues[c.id] = !Utility.isEmpty(c?.defaultValue) ? c.defaultValue[0] : "";
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return {
                        id: p,
                        name: p
                    }
                });
                group['type'] = INPUT_TYPE.DROPDOWN;
                group['options'] = options;
                group['isMultiSelect'] = true;
                group['validation'] = [];
                if(c.isMandatory) {
                    group['validation'] = [...group['validation'], 'required']
                }
                formValues[c.id] = EmployeeListService.getValueFromMuliSelect(c?.defaultValue, options, "id");
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                group['validation'] = [];
                if(c.isMandatory) {
                    group['validation'] = [...group['validation'], 'required']
                }
                break;  
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    const updateLocationColumnConfig = (config) => {
        const { isLocationActive, locationSettings } = getLocationActiveStatus();
        if (isLocationActive) {
            const columnName = isLocationActive ? locationSettings?.locationLabel : "";
            const locationColumn = {};
            const { content } = locationData;
            const dimension = content?.find(l => {
                return l.label == "LOCATION"
            })
            const attributes = dimension ? dimension["attributes"] : []
            const locationOptions = attributes && attributes.map((x) => {
                return {
                    id: x.id,
                    name: x.value,
                    ...x
                };
            });
            locationColumn["name"] = columnName;
            locationColumn["columnCode"] = "location";
            locationColumn["key"] = "location";
            locationColumn["id"] = "location";
            locationColumn["options"] = locationOptions;
            locationColumn['type'] = INPUT_TYPE.DROPDOWN;
            locationColumn['uiVisible'] = true;
            formValues["location"] = EmployeeListService.getValueObjectFromDropdown(dataToUpdate['location'], locationOptions, "id");
            config.push(locationColumn);
        }
        return config;
    }

    const getLocationActiveStatus = () => {
        let isLocationActive = false;
        const { additionalSettings } = tenantDetails || "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;

        return { isLocationActive, locationSettings };
    }

    const updateFormConfigForEdit = (columnConfig) => {
        const config = columnConfig;
        const alteredConfig = [];
        config.forEach((c) => {
            switch (c.columnCode) {
                case "workingHoliday":
                    alteredConfig.push({ columnCode: c.columnCode, readOnly: true });
                    break
                case "expiryAt":

                    alteredConfig.push({columnCode: c.columnCode, type: dataToUpdate?.isExpiryNumOfDays ? INPUT_TYPE.NUMBER : INPUT_TYPE.DATE, readOnly: true, name :  dataToUpdate?.isExpiryNumOfDays ? "Expiry In (Days)" : "Expiry On" })
                    break
                case "isForAllUsers":
                    alteredConfig.push({ columnCode: c.columnCode, readOnly: true });
                    break;
                case "compOffFor":
                    if (dataToUpdate['isForAllUsers']) {
                        alteredConfig.push({ columnCode: c.columnCode, uiVisible: false, readOnly: true, validation: [] });
                    } else {
                        alteredConfig.push({ columnCode: c.columnCode, uiVisible: true, readOnly: true, validation: ['required'] });
                    }
                    break;
                default:
                    break;
            }
        });
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});

    };

    const updateFormFieldConfigOptions = () => {
        const config = deepClone(formFieldConfig);
        const { users } = userList;
        const options = users?.map((u) => {
            return {
                id: u.userId,
                name: `${u.firstName} ${u.lastName}`,
                ...u
            }
        })

        const alteredFields = [{ columnCode: "compOffFor", options: options }]
        EmployeeListService.getAlteredConfigDetails(config, alteredFields, false, {}, {});
        return config;

    }

    const updateFormValues = (config) => {

        formValues['description'] = dataToUpdate['description'];
        formValues['isForAllUsers'] = dataToUpdate['isForAllUsers'] ? { "id": "Y", name: "Yes" } : { id: "N", name: "No" };
        formValues['isAttachmentMandatory'] = dataToUpdate['isAttachmentMandatory'] ? { "id": true, name: "Yes" } : { id: false, name: "No" };
        formValues['workingHoliday'] = moment(dataToUpdate['workingHolidayFrom'], "YYYY-MM-DD");
        formValues['duration'] = dataToUpdate['duration'] === 1 ? "fullDay" : "halfDay";
        formValues['expiryMode'] = dataToUpdate['isExpiryNumOfDays'] ? "noOfDays" : "date";
        formValues['expiryAt'] = dataToUpdate['isExpiryNumOfDays'] ? dataToUpdate['expiryDuration'] : (moment(dataToUpdate['expiryDate'], "YYYY-MM-DD")).toDate();
        formValues['compOffFor'] = dataToUpdate['isForAllUsers'] ? [] : getSelectedUserInEditCase();
        updateLocationFieldValue(config);
        updateCustomFieldValues(config);
    }

    const updateLocationFieldValue = (config) => {
        let index = config.findIndex(c => c.columnCode === "location");
        if (index != -1) {
            const options = config[index].options
            formValues['location'] = EmployeeListService.getValueObjectFromDropdown(parseInt(dataToUpdate['location']), options, "id")
        }
    }

    const updateCustomFieldValues = (config) => {
        let { customFieldsData } = dataToUpdate;
        customFieldsData?.forEach((c) => {
            let index = config.findIndex(f => f.columnCode === c.fieldId);
            if (index != -1) {
                const field = config[index];
                updateCustomFieldValuesInEdit(field, c);
            }
        })
    }

    const updateCustomFieldValuesInEdit = (field, customField) => {
        switch (field.type) {
            case INPUT_TYPE.DROPDOWN:
                formValues[field.columnCode] = getValueForMultiSelect(customField?.optionValues, field.options, "id")
                break;
            case INPUT_TYPE.NUMBER:
                formValues[field.columnCode] = customField?.numberValue;
                break;
            case INPUT_TYPE.TEXT:
                formValues[field.columnCode] = customField?.stringValue;
                break;
            case INPUT_TYPE.DATE:
                const date = moment(Utility.formatDate(customField?.stringValue)).toDate();
                formValues[field.columnCode] = Utility.isValidDate(date) ? reverseTimezoneOffset(date) : "";              
                break;    
            default:
                formValues[field.columnCode] = customField?.fieldValue[0];
                break;
        }
    }

    const getValueForMultiSelect = (value, options, key) => {
        let selectedOptions = [];
        if (value?.length > 0 && options?.length > 0) {
            value.forEach((i) => {
                let index = options.findIndex(o => o[key] === i);
                if (index != -1) {
                    selectedOptions.push(index);
                }

            });
        }
        return selectedOptions
    }

    const getSelectedUserInEditCase = () => {
        const iamUserIds = dataToUpdate['users'];
        const selectedUsers = [];
        const { users } = userList;
        if (!Utility.isEmpty(iamUserIds)) {
            iamUserIds.forEach(x => {
                let index = users.findIndex(u => parseInt(u.iamUserId) === x);
                if (index != -1) {
                    selectedUsers.push(index);
                    // let group = {
                    //     id: users[index].userId,
                    //     name: `${users[index].firstName} ${users[index].lastName}`,
                    //     ...users[index].userId
                    // }
                    // selectedUsers.push(group);
                }
            });
        }
        return selectedUsers;
    }

    const onChange = (v, c) => {
        const config = deepClone(formFieldConfig);
        const alteredConfig = [];

        if (typeof v === "string" && v.trim().length === 0) {
            v =  v.trim()
         }   

        switch (c.columnCode) {
            case "isForAllUsers":
                if (!Utility.isEmpty(v) && EmployeeListService.getSelectedIdFromObject(v, "id") === "Y") {
                    formValues["compOffFor"] = [];
                    alteredConfig.push({ columnCode: "compOffFor", uiVisible: false, validation: [] });
                } else {
                    alteredConfig.push({ columnCode: "compOffFor", uiVisible: true, validation: ['required'] });
                }
                formValues[c.columnCode] = v;
                break;
            case "workingHoliday":
                formValues["expiryAt"] = ""
                formValues[c.columnCode] = v;
                setProcessing(true);
                const params = { condition: [{ key: "workingHolidayFrom", value: moment(v).format("YYYY-MM-DD") }] };
                CompoffService.getAlreadyExistCompoffsList(params).then((response) => {
                    if (!Utility.isEmpty(response)) {
                        checkValidationForExistingCompOff(response, c, config);
                        setProcessing(false);
                    }
                }, (err => {
                    setProcessing(false);
                    showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
                }))
                break;
            case "expiryAt" :
                
                if (typeof v === "string") {
                    v =  v.trim()   
                }   
            default:
                formValues[c.columnCode] = v;
                let { invalid, errMsg } = checkFieldValidation(c, v);
                if (invalid) {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                } else {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: invalid, errMsg: errMsg })
                }
                
                break;
        }
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});
        setFormFieldConfig(config);
    }

    const checkValidationForExistingCompOff = (res, c, columns) => {
        const columnConfig = deepClone(columns);
        const alteredConfig = [];
        const { data } = res;
        if (!Utility.isEmpty(data?.length)) {
            let compOffDuration = 0;
            data?.forEach((d) => {
                compOffDuration += d.duration;
            })
            if (compOffDuration === 1) {
                alteredConfig.push({ columnCode: c.columnCode, hasError: true, errMsg: t("INITIATE_COMPOFF_ALREADY_EXIST"), validation:["required","alreadyExist"]});
            } else if (compOffDuration === 0.5) {
                const selectedDuration = formValues['duration'];
                if (!Utility.isEmpty(selectedDuration) && selectedDuration === "fullDay") {
                    alteredConfig.push({ columnCode: "duration", hasError: true,tooltiptext: t("HALF_DAY_COMPOFF_ALREADY_EXIST"),validation:["required","alreadyExist"]});
                } else {
                    alteredConfig.push({ columnCode: c.columnCode, hasError: false, errMsg: CONSTANTS.EMPTY_STRING, validation:["required"] });
                    alteredConfig.push({ columnCode: "duration", hasError: false, tooltiptext: CONSTANTS.EMPTY_STRING , validation:["required"]});
                }
            }
        } else {
            alteredConfig.push({ columnCode: c.columnCode, hasError: false, errMsg: CONSTANTS.EMPTY_STRING, validation:["required"] });
            alteredConfig.push({ columnCode: "duration", hasError: false, tooltiptext: CONSTANTS.EMPTY_STRING, validation:["required"] });
        }
        EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false, {}, {});
        setExistingCompOffData(res);
        setFormFieldConfig(columnConfig)
    }

    const checkDurationValidationForExistingCompOff = (c, v, alteredConfig) => {
        const { data } = existingCompOffData;
        if (!Utility.isEmpty(data)) {
            let compOffDuration = 0;
            data?.forEach((d) => {
                compOffDuration += d.duration;
            });
            const balance = 1 - compOffDuration;
            if (balance === 0.5 && v === "halfDay") {
                alteredConfig.push({ columnCode: c.columnCode, hasError: false, tooltiptext: CONSTANTS.EMPTY_STRING, validation:["required"] });
            } else if (balance === 0.5 && v === "fullDay") {
                alteredConfig.push({ columnCode: c.columnCode, hasError: true, tooltiptext: t("HALF_DAY_COMPOFF_ALREADY_EXIST"), validation:["required","alreadyExist"]});
            }
        } else {
            alteredConfig.push({ columnCode: c.columnCode, hasError: false, tooltiptext: CONSTANTS.EMPTY_STRING, validation:["required"] });
        }
    }

    const onRadioButtonChange = (c, r) => {
        if (isEdit) return;
        let columnConfig = deepClone(formFieldConfig);
        const alteredConfig = [];
        switch (c.columnCode) {
            case "expiryMode":
                switch (r.fieldId) {
                    case "noOfDays":
                        alteredConfig.push({ columnCode: "expiryAt", name: "Expiry In (Days)", type: INPUT_TYPE.NUMBER });
                        formValues["expiryAt"] = CONSTANTS.EMPTY_STRING;
                        break;
                    case "date":
                        alteredConfig.push({ columnCode: "expiryAt", name: "Expiry On", type: INPUT_TYPE.DATE });
                        formValues["expiryAt"] = CONSTANTS.EMPTY_STRING;
                        break;

                }
                formValues[c.columnCode] = r.fieldId
                break;
            case "duration":
                formValues[c.columnCode] = r.fieldId;
                checkDurationValidationForExistingCompOff(c, r.fieldId, alteredConfig);
                break;

            default:
                formValues[c.columnCode] = r.fieldId;
                break;
        }
        EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false, {}, {});
        setFormFieldConfig(columnConfig);
    }


    const getFieldRequired = (field) => {
        const validator = field.validation;
        let isRequired = false;
        if (validator && validator.some(x => x === "required")) isRequired = true;
        return isRequired;

    }

    const getFormParams = () => {
        let params = {
            workingHolidayFrom: getWorkingHoliday(),
            workingHolidayTo: getWorkingHoliday(),
            expiryDuration: getExpiryDuration(),
            duration: getCompOffDuration(),
            isExpiryNumOfDays: isExpiryNumOfDays(),
            expiryDate: getExpiryDate(),
            description: formValues['description'],
            isForAllUsers: EmployeeListService.getSelectedIdFromObject(formValues['isForAllUsers'], "id") === "Y",
            isAttachmentMandatory: formValues['isAttachmentMandatory']?.id ? formValues['isAttachmentMandatory'].id : false,
            users: EmployeeListService.getSelectedIdFromObject(formValues['isForAllUsers'], "id") === "Y" ? [] : getAllUsersIAMUserIds(),
            location: EmployeeListService.getSelectedIdFromObject(formValues['location'], "id").toString()
        }
        params = updateFormValuesForLocationAndCustomFields(params);
        return params;
    }

    const updateFormValuesForLocationAndCustomFields = (params) => {
        let { customFields } = customFieldsData;
        const customFieldsValues = []
        customFields = customFields?.filter(field=>field.isActive) || [];
        customFields?.forEach((c) => {
            switch (c.type) {
                case "text":
                    let group = {
                        fieldId: c.id,
                        fieldName: c.name,
                        fieldType: c.type,
                        stringValue: formValues[c.id]
                    }
                    customFieldsValues.push(group)
                    break;
                case "number":
                    let group2 = {
                        fieldId: c.id,
                        fieldName: c.name,
                        fieldType: c.type,
                        numberValue: parseFloat(formValues[c.id])
                    }
                    customFieldsValues.push(group2)
                    break;
                case "multiselect":
                    let group1 = {
                        fieldId: c.id,
                        fieldName: c.name,
                        fieldType: c.type,
                        optionValues: formValues[c.id].map((value) => {
                            return c.possibleValues[value]
                        })
                    }
                    customFieldsValues.push(group1)
                    break;
                case "date":
                    const groupDate = {
                        fieldId: c.id,
                        fieldName: c.name,
                        fieldType: c.type,
                        stringValue: convertDateToJson(formValues[c.id])
                    }
                    customFieldsValues.push(groupDate);
                    break;
                default:
                    break;
            }

        });
        params['customFieldsData'] = customFieldsValues;
        return params
    }


    const getAllUsersIAMUserIds = () => {
        const selectedUsers = formValues['compOffFor'];
        const { users } = userList;
        let iamUserIds = [];
        if (!Utility.isEmpty(selectedUsers)) {
            selectedUsers.forEach((s) => {
                iamUserIds.push(parseInt(users[s]['iamUserId']))
            })
        }
        return iamUserIds;
    }

    const getCompOffDuration = () => {
        if (!Utility.isEmpty(formValues['duration']) && formValues['duration'] === "fullDay") {
            return 1;
        } else {
            return 0.5
        }
    }

    const getExpiryDuration = () => {
        let isExpiryOnDays = isExpiryNumOfDays();
        if (isExpiryOnDays) {
            const noOfDays = formValues['expiryAt'];
            return parseInt(noOfDays);
        } else {
            const expiryDate = moment(formValues['expiryAt']);
            const todaysDate = moment();
            const days = expiryDate.diff(todaysDate, 'days');
            return days;
        }
    }

    const getExpiryDate = () => {
        let isExpiryOnDays = isExpiryNumOfDays();
        if (isExpiryOnDays) {
            const noOfDays = formValues['expiryAt'];
            return moment(formValues['workingHoliday']).add(noOfDays, 'days').format("YYYY-MM-DD");
        } else {
            return moment(formValues['expiryAt']).format("YYYY-MM-DD");
        }
    }

    const isExpiryNumOfDays = () => {
        if (!Utility.isEmpty(formValues["expiryMode"])) {
            return formValues["expiryMode"] === "noOfDays";
        }
    }

    const getWorkingHoliday = () => {
        if (!Utility.isEmpty(formValues["workingHoliday"])) {
            return moment(formValues["workingHoliday"]).format("YYYY-MM-DD");
        }
    }

    const checkIfSelectedDateIsWorkingHoliday = () => {
        // const selectedDate = formValues['workingHoliday'];
    }

    const onSave = () => {
        const { invalid, params } = checkValidation();
        if (invalid) {
            return;
        }
        const paramters = getFormParams();
        if (!isEdit && Utility.isEmpty(dataToUpdate['id'])) {
            showLoader(t("COMP_OFF__INITIALIZED_SAVE_IN_PROGRESS"))
            CompoffService.postInitialisedCompoff(paramters).then((response) => {
                showToast(t("COMP_OFF_INITIALIZED_SUCCESS"), TOAST_TYPE.SUCCESS);
                removeLoader();
                props.onClose(true);
            }, (err) => {
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
                props.onClose(false);
                removeLoader();
            })
        } else {
            paramters['id'] = dataToUpdate['id'];
            showLoader(t("COMP_OFF__INITIALIZED_UPDATE_IN_PROGRESS"))
            CompoffService.updateInitialisedCompoff(paramters).then((response) => {
                showToast(t("COMP_OFF_INITIALIZED_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS);
                removeLoader();
                props.onClose(true);
            }, (err) => {
                showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
                removeLoader();
                props.onClose(false);
            })
        }

    }

    const checkValidation = () => {
        let config = deepClone(formFieldConfig);
        const params = {};
        const alteredConfig = [];
        const invalidFields = [];
        for (let c = 0; c < config.length; c++) {
            let { invalid, errMsg } = checkFieldValidation(config[c], formValues[config[c].columnCode]);
            if (invalid) {
                invalidFields.push(config[c].columnCode)
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
            } else {
                alteredConfig.push({ columnCode: config[c].columnCode, hasError: invalid, errMsg: errMsg })
                params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
            }
            switch (config[c].type) {
                case INPUT_TYPE.DROPDOWN:
                    params[config[c].columnCode] = EmployeeListService.getSelectedIdFromObject(formValues[config[c].columnCode], "id");
                    break;

                default:
                    params[config[c].columnCode] = formValues[config[c].columnCode]
                    break;
            }
        }
        const invalid = invalidFields.length > 0;
        EmployeeListService.getAlteredConfigDetails(config, alteredConfig, false, {}, {});
        setFormFieldConfig(config);
        return { params, invalid }
    }

    const checkFieldValidation = (config, value) => {
        const validation = config.validation
        let invalid = false;
        let errMsg = CONSTANTS.EMPTY_STRING;
        if (!Utility.isEmpty(validation)) {
            for (let v = 0; v < validation.length; v++) {
                switch (validation[v]) {
                    case "required":
                        if (Utility.isEmpty(value)) {
                            invalid = true;
                            errMsg = "Enter a valid value"
                        }
                        break;
                    case "maxLength":
                        if (!Utility.isEmpty(value) && value.length > parseInt(config?.maxLength)) {
                            invalid = true;
                            errMsg = `Length should not exceed ${config?.maxLength} digits`
                        }
                        break;
                    case "decimalPrecision":
                        if (!Utility.isEmpty(value)) {
                            var result = (value - Math.floor(value)) === 0; 
                            if (result) {
                                break
                            }

                            const valueArray = (value?.toString())?.split(".");
                            if (valueArray.length > 1) {
                                const precisionValue = valueArray[1];
                                if (precisionValue.length > parseInt(config.decimalPrecision)) {
                                    invalid = true;
                                    errMsg = `Length after decimal should not exceed ${config?.decimalPrecision} digits`
                                }
                            }
                        }
                        break;
                    case "greaterThan"    :
                        if ( !Utility.isEmpty(formValues[config.greaterThanField[0].key]) && formValues[config.columnCode] instanceof Date) {
                                let field1 = moment(formValues[config.greaterThanField[0].key])
                                let field2 = moment(value)
                                if(moment(field1).isAfter(field2)) {
                                    invalid = true;
                                    errMsg = `${config.name} should be greater than ${config.greaterThanField[0].name}`
                                }
                            }
                            
                        break
                    default:
                        invalid = config.hasError;
                        errMsg = config.errMsg;
                        break;
                }
            }
        }
        return { invalid, errMsg }
    }

    const getRadioButtons = (c) => {
        return c.radioButtons.map(r => {
            return (
                <div className="row" style={{ width: "auto" }}>
                    <DKRadioButton
                        isSelected={r.fieldId === formValues[c.columnCode]}
                        color="bg-app"
                        onClick={() => {
                            onRadioButtonChange(c, r)
                            // formValues[c.columnCode] = r.fieldId
                            // let columnConfig = deepClone(formFieldConfig);
                            // // columnConfig[c.columnCode] = radioField.fieldId;
                            // setFormFieldConfig(columnConfig);
                        }}
                    />
                    <DKLabel className="ml-s mr-l" text={r.fieldLabel} />
                </div>
            )
        })
    }

    const getFormSection = () => {
        return (
            formFieldConfig.map((c) => {
                return (
                    <>

                        {c.type === INPUT_TYPE.DROPDOWN && c.uiVisible && (
                            <div
                                className="column p-h-l  mb-xxl padding-bottom-mobile"
                                key={c.columnCode}
                            >
                                <DKInput
                                    title={c.name}
                                    placeholder={c.name}
                                    value={formValues[c.columnCode]}
                                    className=''
                                    formatter={(obj) => {
                                        /** How to render a selected option in case of object **/
                                        return obj.name;
                                    }}
                                    displayKey={"name"}
                                    options={c.options}
                                    type={c.type}
                                    labelClassName=" text-align-left "
                                    onChange={(v) => {
                                        onChange(v, c);
                                    }}
                                    direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
                                    required={getFieldRequired(c)}
                                    readOnly={c.readOnly}
                                    onClick={() => { }}
                                    tooltip={{
                                        content: c.tooltipMsg,
                                        className: "warning-tooltip-prop",
                                    }}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch: c.options && c.options.length > 6 ? true : false,
                                        searchableKey: "name",
                                        data: c.options,
                                        renderer: (index, obj) => {
                                            /*How to render dropdwon options from string of array*/
                                            return <DKLabel className="" text={obj.name} />;
                                        },
                                        onSelect: (index, value) => { },
                                        multiSelect: c.isMultiSelect,
                                    }}
                                    canValidate={c.hasError}
                                    validator={(value) => {
                                        return !c.hasError;
                                    }}
                                    errorMessage={c.errMsg}
                                />
                            </div>
                        )}
                        {(c.type === INPUT_TYPE.TEXT || c.type === INPUT_TYPE.DATE || c.type === INPUT_TYPE.NUMBER) && (
                            <div
                                className="column p-h-l mb-xxl padding-bottom-mobile"
                                key={c.columnCode}
                            >
                                <DKInput
                                    title={c.name}
                                    placeholder={c.name}
                                    value={formValues[c.columnCode]}
                                    className=''
                                    type={c.type}
                                    labelClassName=" text-align-left "
                                    onChange={(v) => {
                                        onChange(v, c);
                                    }}
                                    direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
                                    required={getFieldRequired(c)}
                                    readOnly={c.readOnly}
                                    onClick={() => { }}
                                    canValidate={c.hasError}
                                    validator={(value) => {
                                        return !c.hasError;
                                    }}
                                    errorMessage={c.errMsg}
                                />
                            </div>
                        )}
                        {c.type === "radio" && (
                            <div className={`column p-h-l mb-xxl padding-bottom-mobile ${c.columnCode}`}>
                                <div className="row row-responsive justify-content-start position-relative align-items-start">
                                    <div className="mr-l">
                                        <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                                            <DKLabel className="" text={`${c.name}${getFieldRequired(c) ? ` *` : ''}`} />
                                            {c.hasError && (
                                                <DKTooltipWrapper
                                                    content={c.tooltiptext}
                                                    tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                                >
                                                    <DKIcon
                                                        src={ic_erro_info}
                                                        className="ml-s ic-s ml-r mt-xs cursor-hand "

                                                    />
                                                </DKTooltipWrapper>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                                        {c.radioButtons && getRadioButtons(c)}
                                    </div>
                                </div>
                            </div>

                        )}

                    </>
                )
            })
        )
    }

    const getHeader = () => {
        return (
            <div className="row justify-content-between p-h-m">
                <div className="row">
                    <DKLabel
                        text={`${!props.isEdit ? "Initialize Comp Off" : "Edit Initializes Comp Off"}`}
                        className="fw-b fs-m"
                    />
                    {isProcessing && <DKSpinner className="pl-s" />}
                </div>
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            props.onClose(false);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <div className=" transparent-background">
                <div className="p-h-r pt-r pb-m popup-window" style={{ maxWidth: "40%", width: "100%" }}>
                    <div className="popup-wrapper parent-width parent-height">
                        {getHeader()}
                        <div
                            // style={{
                            //     display: "flex",
                            //     flexWrap: "wrap",
                            // }}
                            className=" parent-width parent-width pb-m pt-l"
                        >
                            {getFormSection()}
                        </div>
                        {/* <div className="p-m">{getFormSection()}</div> */}
                    </div>
                </div>

            </div>
        </>
    )

}

export default InitialiseCompOff;